import type { Message } from '@/types';

/** 规范化消息文本：trim + 合并连续空白 + 转小写。 */
export function normalizeMessage(text: string): string {
  return text.trim().replace(/\s+/g, ' ').toLowerCase();
}

export interface DuplicateResult {
  found: boolean;
  /** 是否为最后一条 user 消息。 */
  isLatest: boolean;
  index: number;
}

/**
 * 在消息历史中查找重复的 user 指令（倒序遍历，仅比对 user 文本消息）。
 * 返回第一个匹配结果，或 null 表示无重复。
 */
export function findDuplicateInHistory(input: string, messages: Message[]): DuplicateResult | null {
  const normalized = normalizeMessage(input);
  if (!normalized) return null;

  let lastUserIndex = -1;
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === 'user') { lastUserIndex = i; break; }
  }

  for (let i = messages.length - 1; i >= 0; i--) {
    const msg = messages[i];
    if (msg.role !== 'user') continue;
    if (normalizeMessage(msg.content ?? '') === normalized) {
      return { found: true, isLatest: i === lastUserIndex, index: i };
    }
  }
  return null;
}
